"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bars = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var link_1 = require("../../structure/link");
function classNames() {
  var classes = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    classes[_i] = arguments[_i];
  }
  return classes.filter(Boolean).join(" ");
}
var Bars = /** @class */function (_super) {
  __extends(Bars, _super);
  function Bars() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.renderBarColor = function (type, selected) {
      var className = "";
      var color = _this.props.primaryColor;
      var cusColorText = "bg-primary-500";
      var cusColorIcon = "hover:bg-primary-400";
      switch (_this.props.customColor) {
        case "red":
          cusColorText = "bg-red-500";
          cusColorIcon = "hover:bg-red-400";
          break;
        case "orange":
          cusColorText = "bg-orange-500";
          cusColorIcon = "hover:bg-orange-400";
          break;
        case "yellow":
          cusColorText = "bg-yellow-500";
          cusColorIcon = "hover:bg-yellow-400";
          break;
        case "green":
          cusColorText = "bg-green-500";
          cusColorIcon = "hover:bg-green-400";
          break;
        case "blue":
          cusColorText = "bg-blue-500";
          cusColorIcon = "hover:bg-blue-400";
          break;
        case "indigo":
          cusColorText = "bg-indigo-500";
          cusColorIcon = "hover:bg-indigo-400";
          break;
        case "violet":
          cusColorText = "bg-violet-500";
          cusColorIcon = "hover:bg-violet-400";
          break;
        default:
          break;
      }
      if (type === "text") {
        if (selected) {
          className = "".concat(color ? "".concat(cusColorText, " text-white") : "bg-gray-100 text-gray-900");
        } else {
          className = "text-gray-600 ".concat(color ? "".concat(cusColorIcon, " hover:text-white") : "hover:bg-gray-50 hover:text-gray-900", " ");
        }
      } else {
        if (selected) {
          className = "".concat(color ? "text-white" : "text-gray-500");
        } else {
          className = "".concat(color ? "text-gray-500 group-hover:text-white" : "text-gray-400 group-hover:text-gray-500");
        }
      }
      return className;
    };
    return _this;
  }
  Bars.prototype.render = function () {
    var _this = this;
    var selectedId = this.props.selectedId;
    return react_1.default.createElement("nav", {
      className: "space-y-1",
      "aria-label": "Sidebar"
    }, this.props.bars.map(function (item) {
      var containerClassName = classNames(_this.renderBarColor("text", item.id === selectedId), "group flex items-center px-3 py-2 text-sm font-medium rounded-md");
      var childrenComponent = react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(item.icon, {
        className: classNames(_this.renderBarColor("icon", item.id === selectedId), "flex-shrink-0 -ml-1 mr-3 h-6 w-6"),
        "aria-hidden": "true"
      }), react_1.default.createElement("span", {
        className: "truncate"
      }, item.name));
      if (_this.props.onClick) {
        return react_1.default.createElement("div", {
          key: item.name,
          className: containerClassName,
          onClick: _this.props.onClick.bind(_this, item.id)
        }, childrenComponent);
      } else {
        return react_1.default.createElement(link_1.Link, {
          key: item.name,
          href: item.href,
          className: containerClassName,
          linkType: _this.props.linkType,
          custom: _this.props.custom
        }, childrenComponent);
      }
    }));
  };
  return Bars;
}(react_1.Component);
exports.Bars = Bars;